import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgTimeAlwaysGlyphSecondary from './svgs/TimeAlwaysGlyphSecondary.js';
import SvgTimeAlwaysGlyph from './svgs/TimeAlwaysGlyph.js';
import { useIcon } from '../../shared-components/icon/index.js';

var timeAlwaysGlyph = (props => useIcon(SvgTimeAlwaysGlyph, SvgTimeAlwaysGlyphSecondary, props));

export { timeAlwaysGlyph as default };
